import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';

const HomePage = React.lazy(() => import('../main/pages/home-page'));

export const mainRoutePaths = {
  home: '/',
} as const;

export const mainRoutes: Sebrae.RoutesConfig = [
  {
    routePath: mainRoutePaths.home,
    pageToRender: <HomePage />,
  },
];
